import { CatalogEntryQuestion } from '@apps/its2/domain/models';

export class Answer
{
    constructor (public question: CatalogEntryQuestion, public response: string)
    {
    }

    public toSummary (language: string)
    {
        return `
            <div class="summary-field label">${this.question.label[language]}</div>
            <div class="summary-field value">: ${this.response}</div>
        `;
    }

    public toDescription (language: string)
    {
        return `<li>${this.question.label[language]}: ${this.response}</li> `;
    }
}
